export default "__VITE_ASSET__RnfVdAZe__"